import { render, staticRenderFns } from "./DistributeLeadIcon.vue?vue&type=template&id=00a0263c&scoped=true&"
import script from "./DistributeLeadIcon.vue?vue&type=script&lang=js&"
export * from "./DistributeLeadIcon.vue?vue&type=script&lang=js&"
import style0 from "./DistributeLeadIcon.vue?vue&type=style&index=0&id=00a0263c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a0263c",
  null
  
)

export default component.exports